
(() => {
  function initialiseAfterpaySync() {
    const picker = document.querySelector('block-variant-picker');
    const placement = document.querySelector('square-placement[data-amount]');

    if (!picker || !placement) return;

    function updateAfterpay() {
      const variant = picker.currentVariant;

      if (!variant || typeof variant.price !== 'number') return;

      const amount = (variant.price / 100).toFixed(2);

      if (placement.getAttribute('data-amount') !== amount) {
        placement.setAttribute('data-amount', amount);
      }
    }

    picker.addEventListener('change', () => {
      setTimeout(updateAfterpay, 0);
    });

    updateAfterpay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAfterpaySync);
  } else {
    initialiseAfterpaySync();
  }
})();
